import React from "react";
import FormNavigation from "../navigation.component";
import ImageManager from "components/ImageManager";

const ImageUpload = (props) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      props.nextStep();
    }}
  >
    <ImageManager {...props} />
    <FormNavigation showSkipBtn {...props} />
  </form>
);

export default ImageUpload;
